import React, { Component } from 'react'
import { imageAddress, translate } from '../utils/useful'

export default class CallTower extends Component {
    state = {
        voicecall: { profile: '/assets/images/avatar-voice-call.jpg', name: 'Corey Culhane' },
        endCall: false
    }
    answer = () => {

    }
    reject = () => {

    }
    render() {
        let voicecall = this.state.voicecall
        return (
            <div className='w-100 flexcc'>
                <div className='flexcb p-3' style={{ width: '300px', backgroundColor: '#fff', borderBottom: '1px solid #eee' }}>
                    <div className='flexcc'>
                        <div className=' br-10' style={{ width: '40px', height: '40px' }}>
                            <img className='br-10' width={40} src={voicecall.profile} alt="" />
                        </div>
                        <div className='mld-3'>
                            <p className='font-size-13 weight-600' style={{ color: "#222", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", maxWidth: "140px" }}>{voicecall.name}</p>
                            <div className='flexc mt-1'>
                                <p className='font-size-10 prd-3' style={{ color: '#34C759' }}>{translate('Voice Call')}</p>
                                <p className='font-size-10' style={{ color: "#222", }}>10:17</p>
                            </div>
                        </div>
                    </div>
                    <div className='flexc'>
                        <button className='flexcc br-30' style={{ backgroundColor: '#FF0E00', width: '35px', height: '35px' }} onClick={() => { this.reject() }}>
                            <img width={28} height={28} className='br-50' src="/assets/icons/tower/end-call.svg" alt="" />
                        </button>
                        {!this.state.endCall &&
                            <button className='flexcc br-30 mld-2' style={{ backgroundColor: '#34C759', width: '35px', height: '35px' }} onClick={() => { this.answer(); this.setState({ endCall: !this.state.endCall }) }}>
                                <img width={28} height={28} className='br-50' src="/assets/icons/tower/call.svg" alt="" />
                            </button>
                        }
                    </div>
                </div>
            </div>
        )
    }
}
